import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';
import withAnimation from '../../../../shared/components/utils/hoc/withAnimation';

interface Props {
  displacePosition?: boolean;
  displaceMenu?: boolean;
}

const MosaicContainer = styled.div<Props>`
  left: ${(props) => (props.displaceMenu ? 396 : 94) * Screen.widthRatio}px;
  position: relative;
  top: ${(props) => (props.displacePosition ? 602 : 144) * Screen.widthRatio}px;
  width: ${1920 * Screen.widthRatio}px;
`;

export default withAnimation(MosaicContainer);
